import { config } from '../config.js';

/**
 * Build a game WebSocket URL with query params.
 * @param {string} gameId
 * @param {string} playerId
 */
export function buildGameWebSocketUrl(gameId, playerId) {
  let baseUrl = config.apiBaseUrl.replace('/api', '');
  const wsUrl = baseUrl.replace('http://', 'ws://').replace('https://', 'wss://');
  const path = `/ws/games/${gameId}`;
  const auth = getTelegramInitData();
  const query = new URLSearchParams();
  if (playerId) {
    query.set('player_id', playerId);
  }
  if (auth) {
    query.set('auth', auth);
  }

  if (wsUrl === '/' || wsUrl === '') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}${path}?${query.toString()}`;
  }

  return `${wsUrl}${path}?${query.toString()}`;
}

function getTelegramInitData() {
  if (window.Telegram?.WebApp?.initData) {
    return window.Telegram.WebApp.initData;
  }

  const hash = window.location.hash?.slice(1) || '';
  const params = new URLSearchParams(hash);
  const fromHash = params.get('tgWebAppData');
  if (fromHash) {
    return decodeURIComponent(fromHash);
  }

  return null;
}
